// extracted by mini-css-extract-plugin
export default {"marketingConsentRoot":"CustomSignupForm_marketingConsentRoot__HQVkA","finePrint":"CustomSignupForm_finePrint__uZTkJ marketplaceModalHelperLink"};